import { call, put, takeLatest, fork } from 'redux-saga/effects';
import {
  LOAD_METADATA,
  LOAD_METADATA_SUCCESS,
  LOAD_METADATA_ERROR,
} from './constants';
import metaDataService from '~/services/metaDataService';

function* loadMetaData(action) {
  let lang = action.payload.lang;
  try {
    const { categories } = yield call(metaDataService.getCategories);
    yield put({
      type: LOAD_METADATA_SUCCESS,
      payload: {
        categories,
      },
    });
  } catch (error) {
    yield put({ type: LOAD_METADATA_ERROR, error });
  }
}

export default function* metaDataSaga() {
  yield takeLatest(LOAD_METADATA, loadMetaData);
}
